import { useState, useSyncExternalStore } from 'react'
import { Input, Modal } from 'antd'
import { testSessionStore } from './test-session-store'
import { closeQuickProblemMarkModal, getQuickProblemMarkModalOpen, subscribeQuickProblemMarkModal } from './quick-problem-mark-store'

export default function QuickProblemMarkModal() {
  const visible = useSyncExternalStore(
    subscribeQuickProblemMarkModal,
    getQuickProblemMarkModalOpen,
    getQuickProblemMarkModalOpen,
  )
  const [expected, setExpected] = useState('')
  const [actual, setActual] = useState('')

  const markProblem = () => {
    testSessionStore.markProblem({ expected: expected.trim(), actual: actual.trim() })
    setExpected('')
    setActual('')
    closeQuickProblemMarkModal()
  }

  return <Modal
    rootClassName="devtools-test-session-modal rr-block"
    title="标记功能问题"
    open={visible}
    onCancel={closeQuickProblemMarkModal}
    onOk={markProblem}
    okText="确认标记"
    okButtonProps={{ disabled: !expected.trim() || !actual.trim() }}
  >
    <p className="mb-3 text-sm text-gray-500">标记会随本次测试记录保存，后续复制记录时会一并带出。</p>
    <label className="mb-1 block text-sm text-gray-700" htmlFor="quick-test-session-expected">预期结果</label>
    <Input.TextArea id="quick-test-session-expected" value={expected} onChange={(event) => setExpected(event.target.value)} />
    <label className="mb-1 mt-3 block text-sm text-gray-700" htmlFor="quick-test-session-actual">实际结果</label>
    <Input.TextArea id="quick-test-session-actual" value={actual} onChange={(event) => setActual(event.target.value)} />
  </Modal>
}
